import * as Locale from 'date-fns/locale';

export default async function getDefaultLocale(): Promise<typeof Locale.enAU | typeof Locale.es | typeof Locale.zhCN> {
  const envLanguage = process.env.REACT_DEFAULT_LANGUAGE || 'en-au';
  if (envLanguage.startsWith('es')) return Locale.es;
  if (envLanguage === 'zh-hk') return Locale.zhCN;

  return Locale.enAU;
}
